<template>
  <v-app id="app">
    <router-view/>
  </v-app>
</template>
<script>


export default {
  name: 'App'
};
</script>

<style>
/*#app{
  height: 100%;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: #2f4050;
  font-size: 13px;
  color: #676a6c;
  overflow-x: hidden;
}*/

</style>


// WEBPACK FOOTER //
// src/App.vue